import { render, staticRenderFns } from "./MeasurementBD.vue?vue&type=template&id=0a2e169e&scoped=true&"
import script from "./MeasurementBD.vue?vue&type=script&lang=ts&"
export * from "./MeasurementBD.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e169e",
  null
  
)

export default component.exports